import React from "react";
import bell from "../../assets/svg/bell.svg";
const AppointmentRequest = ({ onClose }) => {
  return (
    <div>
      <h2 className="text-xl font-bold">Appointment Request Sent!</h2>

      <p className="text-[#5D5D5D] text-base text-medium mt-1">
        Your visit has been successfully scheduled. The details have been sent
        for approval, and you’ll receive a confirmation shortly.
      </p>

      <div className="flex gap-3 mt-2">
        <div className="mt-1">
          <i class="fi fi-rr-calendar-clock text-2xl text-[#5D5D5D]"></i>
        </div>

        {/* <div>
          <h6 className="text-lg text-[#5D5D5D] font-semibold">
            Requested Visit Date & Time:{" "}
          </h6>
          {requestData?.map((item, index) => {
            return (
              <>
                {item?.date ? (
                  <p className="text-base text-[#5D5D5D] font-medium">
                    <ul>
                      {item?.visitTime?.map((slotTime, index) => {
                        return (
                          <li>
                            {new Date(item?.date).toDateString()},{" "}
                            {new Date(slotTime?.fromTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )}{" "}
                            -
                            {new Date(slotTime?.toTime).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </li>
                        );
                      })}
                    </ul>

                  </p>
                ) : null}
              </>
            );
          })}
        </div> */}
      </div>

      <div className="flex gap-3 mt-2 items-center mt-4 bg-[#F4F4F4] rounded-[20px] p-3">
        <div>
          <img src={bell} alt="" />
        </div>

        <div>
          <h6 className="text-lg text-[#5D5D5D] font-semibold">What’s Next?</h6>
          <p className="text-base text-[#5D5D5D] font-medium">
            We’ll notify you as soon as your visit is approved. Stay tuned!
          </p>
        </div>
      </div>

      <div className="mt-4 text-right">
        <button
          className="text-white bg-red-600 text-base font-semibold rounded-[45px] px-4 py-2"
          onClick={onClose}
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default AppointmentRequest;
